import trelloBackbone from './trello-backbone.js';

export default trelloBackbone;
